import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Store, BadgeCheck } from "lucide-react";
import { api, fmt } from "../lib/api";
import { DemoBadge, PageTitle, Spinner, Stars } from "../components/ui";

export default function Stores() {
  const [stores, setStores] = useState(null);
  useEffect(() => { api.get("/stores").then(({ data }) => setStores(data)); }, []);
  if (!stores) return <Spinner />;
  return (
    <div data-testid="stores-page">
      <PageTitle title="Lojas e Parceiros" sub="Venda própria BÔ Market e lojas parceiras verificadas pela administração." />
      <div className="grid gap-4 sm:grid-cols-2 2xl:grid-cols-3">
        {stores.map((s) => (
          <Link key={s.id} to={`/catalogo?loja=${s.id}`} data-testid={`store-card-${s.id}`}
            className="bo-card group flex flex-col gap-3 p-5 transition-transform hover:-translate-y-1">
            <div className="flex items-start justify-between gap-2">
              <span className={`grid h-12 w-12 place-items-center rounded-2xl ${s.is_own ? "bg-bo-green text-bo-yellow" : "bg-bo-yellow/30 text-bo-green"}`}>
                <Store className="h-6 w-6" />
              </span>
              <div className="flex gap-1">
                {s.is_own ? <span className="rounded-full bg-bo-green px-2.5 py-1 text-[11px] font-bold text-white">Venda própria</span>
                  : <span className="rounded-full bg-gray-100 px-2.5 py-1 text-[11px] font-bold text-gray-700">Parceiro</span>}
                {s.is_demo && <DemoBadge />}
              </div>
            </div>
            <div>
              <p className="flex items-center gap-1 text-lg font-bold group-hover:text-bo-green">{s.name} <BadgeCheck className="h-4 w-4 text-bo-green" /></p>
              <p className="flex items-center gap-1 text-xs text-gray-500"><MapPin className="h-3 w-3" />{s.location}</p>
            </div>
            <p className="line-clamp-2 text-sm text-gray-600">{s.description}</p>
            <div className="mt-auto flex items-center justify-between border-t border-gray-100 pt-3 text-xs text-gray-600">
              <Stars value={s.rating} />
              <span>{s.products_count} produtos · entrega {fmt(s.delivery_fee)}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
